<template>
    <b-modal id="newSalarySpecificationModal" :title="title" size="md" v-model="visible">
        <date-picker id="dateDropdown" lang="en" 
            v-model="selectedDate" 
            :not-before="notBeforeDate"
            placeholder="Välj datum"
            type="month" 
            format="YYYY-MM"  />    
        <template v-slot:modal-footer>
            <div class="w-100">

            <button class="btn btn-primary float-right"  @click="createSalarySpecification()" :disabled="creating || !selectedDate" v-if="loginState.isAdministrator" >
                <b-spinner v-if="creating" class="mr-1"  type="border" small />{{creating ? 'Bearbetar' : 'Ok'}}
            </button>
            <b-button class="float-right mr-1" @click="visible=false">
                Avbryt
            </b-button>
            </div>
      </template>
    </b-modal>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import { salarySpecificationService } from "../../../shared/services";
export default {
    components: {
        DatePicker,
    },
    props: {
        employee: null
    },  
    computed: {
        title() {
            if(!this.employee) return "";
            return `Skapa lönespecifikation för ${this.employee.firstName} ${this.employee.lastName}`;
        }
    },
    data() {
        return {
            visible: false,
            creating: false,
            notBeforeDate: null,
            selectedDate: null
        };
    },
    methods: {
        show() {
            this.notBeforeDate = this.$moment();
            this.visible = true;
        },
        createSalarySpecification() {
            this.creating = true;
            salarySpecificationService.create(this.employee.id, this.$moment(this.selectedDate).year(), this.$moment(this.selectedDate).month() + 1).then(p => {
                this.$router.push(`/salaryspecifications/${p.id}`)
            }).catch(p =>  {
                if(p.status == 409)
                {
                    this.ShowToast("Fel", "Det existerar redan en lönespecifikation för vald period", "danger");
                    return;
                }
                this.ShowToast("Fel", "Ett okänt fel uppstod då lönespecifikationen skulle skapas", "danger")
            }).finally(() => {
                this.creating = false;
            });

        }
    }
}
</script>

<style>

</style>